/* mm-kannst.js — „Magic Milk ist": Zeilen decken sich beim Scrollen auf.
 *
 * 05.09.2026, Mert (mit Bildschirmaufnahme von aureon-management.de):
 * „mach so eine section rein irgendwo auf der seite passend, genauso, ohne
 * fehler, scroll effect."
 *
 * WAS DAS IST
 * Dieselbe Mechanik wie `aureon-scrollglanz.js` auf der AUREON-Seite, hier
 * fuer das Shopify-Theme in eigenstaendigem Vanilla nachgebaut. Jedes Wort
 * liegt doppelt da: einmal als schwacher „Geist", der die Zeile auf ihrer
 * vollen Breite haelt, und einmal als helle Fassung darueber, deren Deckkraft
 * am Scrollfortschritt haengt. Wort fuer Wort, von links nach rechts, Zeile
 * fuer Zeile von oben nach unten.
 *
 * WARUM DER GEIST WICHTIG IST — und nicht nur Optik
 * Ohne ihn waere die Sektion beim Betreten leer, und das verstoesst gegen
 * Merts feste Regel vom 04.09.2026 („keine langen leeren Felder": Inhalt darf
 * nie von einer Animation abhaengen). Der Geist steht immer da, lesbar; das
 * Aufdecken legt nur Helligkeit darueber. Zusaetzlich gilt:
 *   - ohne JavaScript greift `[data-mmk-bereit]` nie, dann steht alles voll da
 *   - bei `prefers-reduced-motion` ebenso, sofort und ohne Bewegung
 * Der zweite Grund ist der Umbruch: waere die helle Fassung allein im Fluss,
 * wuerde die Zeile beim Aufdecken springen.
 *
 * ANIMATION NUR, WENN JEMAND HINSIEHT (feste Regel 23.08.2026)
 * Ein IntersectionObserver haelt die Schleife an, sobald die Sektion aus dem
 * Bild ist, und `visibilitychange` stoppt sie im versteckten Tab. Gerechnet
 * wird ausserdem nur bei Scroll- und Groessenaenderungen, nicht auf Vorrat.
 */
(function () {
  'use strict';

  /* 05.09.2026: Diese Sektion zerlegt ihre Saetze schon beim Bauen in Woerter.
     Der Beobachter aus mm-englisch.js kaeme damit zu spaet - er saehe nur noch
     einzelne Woerter und muesste englische Woerter in deutsche Wortkaesten
     einsortieren, was bei anderer Satzstellung nicht aufgeht. Darum wird der
     ganze Satz VOR dem Zerlegen durch die Sprachschicht geschickt. Auf der
     deutschen Seite gibt sie ihn unveraendert zurueck. */
  function sp(t) { return (typeof window.mmT === 'function') ? window.mmT(t) : t; }

  var ROT = '#E5142A';

  var VORSPANN = 'Magic Milk ist';

  /* Bewusst beschreibend statt versprechend: was das Produkt IST, nicht was es
     bewirkt. Die letzte Zeile steht hier mit Absicht — offen gesagt, dass es
     keine Garantie gibt, ist Merts eigene Linie und wirkt staerker als jede
     Zusage. Keine Kilo-, Zeit- oder Wirkangaben. */
  var ZEILEN = [
    'ein Appetitanreger.',
    'zehn pflanzliche Zutaten.',
    'ein Stick vor dem Essen.',
    'ohne Koffein, ohne Zuckerschub.',
    'kein Mahlzeitersatz.',
    'keine Garantie — das sagen wir offen.'
  ];

  var css = [
    '#mmKa{background:#151013;color:#F3E9EC;position:relative;',
      'padding:clamp(64px,11vw,132px) 0}',
    '#mmKa .mmKaHuelle{width:min(1180px,92vw);margin:0 auto;',
      'padding-inline:clamp(4px,2vw,20px)}',

    '#mmKa .mmKaAuge{margin:0 0 clamp(14px,2.2vw,22px);color:' + ROT + ';',
      'font-size:.72rem;font-weight:800;letter-spacing:.16em;text-transform:uppercase}',

    /* Die Zeilen tragen die Sektion - deshalb gross, aber mit einer Obergrenze.
       Merts PC-Regel (22.08.2026): am Rechner nie ein Vielfaches vom Handy.
       clamp deckelt bei 3.4rem, statt mit der Fensterbreite weiterzuwachsen. */
    '#mmKa .mmKaZeile{margin:0;font-family:"Bricolage Grotesque","Manrope",sans-serif;',
      'font-weight:800;font-size:clamp(1.6rem,4.6vw,3.4rem);line-height:1.14;',
      'letter-spacing:-.02em;color:#F3E9EC}',
    '#mmKa .mmKaZeile + .mmKaZeile{margin-top:clamp(2px,.6vw,8px)}',

    '#mmKa .mmKaWort{position:relative;display:inline-block;white-space:pre}',

    /* Der Geist steht bei 42 Prozent, nicht bei den 26 der Vorlage. Nachgerechnet
       auf dem echten Untergrund #151013: 26 Prozent Creme ergeben 2,12:1 - das
       ist unlesbar, und eine Sektion, deren Text man erst nach dem Scrollen
       entziffern kann, ist genau das leere Feld aus Merts Regel vom 04.09.2026.
       42 Prozent ergeben 3,63:1 und liegen damit ueber der Schwelle von 3:1 fuer
       grosse Schrift (hier 54 px). Der Unterschied zum aufgedeckten Wort bleibt
       trotzdem deutlich, weil dort zusaetzlich ein roter Schein dazukommt. */
    '#mmKa .mmKaGeist{position:absolute;inset:0;opacity:.42;pointer-events:none}',
    '#mmKa .mmKaEcht{position:relative;opacity:0;',
      'text-shadow:0 0 22px rgba(229,20,42,.34)}',

    /* Kein `will-change`: eine reine Deckkraft-Aenderung braucht keine eigene
       Compositing-Ebene, und bei rund 30 Woertern waeren das 30 Ebenen. */

    '#mmKa .mmKaAufdeck:not([data-mmk-bereit]) .mmKaEcht{opacity:1}',
    '#mmKa .mmKaAufdeck:not([data-mmk-bereit]) .mmKaGeist{opacity:0}',

    '@media(prefers-reduced-motion:reduce){',
      '#mmKa .mmKaEcht{opacity:1!important}',
      '#mmKa .mmKaGeist{opacity:0!important}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmKaStil')) return;
    var s = document.createElement('style');
    s.id = 'mmKaStil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function grenze(w, min, max) { return w < min ? min : (w > max ? max : w); }

  function ruhig() {
    try {
      return window.matchMedia &&
             window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { return false; }
  }

  /* Wo die Sektion hin soll: als Auftakt direkt VOR „Vier Saetze, die wir
     jeden Tag hoeren" - dort stellt sie die Frage, die die Punkte danach
     beantworten. Findet sie das nicht, haengt sie sich vor die Sektion mit
     dem Komplettset, sonst ans Ende. */
  function ziel() {
    return document.getElementById('mmPu') ||
           document.getElementById('mmKo') ||
           document.getElementById('mmWi') || null;
  }

  function bauen() {
    if (document.getElementById('mmKa')) return true;
    var anker = ziel();
    if (!anker || !anker.parentNode) return false;

    stil();

    var sek = document.createElement('section');
    sek.id = 'mmKa';
    sek.setAttribute('aria-label', sp('Was Magic Milk ist'));

    var huelle = document.createElement('div');
    huelle.className = 'mmKaHuelle';

    var auge = document.createElement('p');
    auge.className = 'mmKaAuge';
    auge.textContent = sp(VORSPANN);
    huelle.appendChild(auge);

    var eintraege = [];

    ZEILEN.forEach(function (roh) {
      var text = sp(roh);
      var p = document.createElement('p');
      p.className = 'mmKaZeile mmKaAufdeck';

      var woerter = text.split(' ');
      var echte = [];

      woerter.forEach(function (wort, i) {
        var w = document.createElement('span');
        w.className = 'mmKaWort';

        var geist = document.createElement('span');
        geist.className = 'mmKaGeist';
        geist.setAttribute('aria-hidden', 'true');
        geist.textContent = wort;

        var echt = document.createElement('span');
        echt.className = 'mmKaEcht';
        echt.textContent = wort;

        w.appendChild(geist);
        w.appendChild(echt);
        p.appendChild(w);
        if (i < woerter.length - 1) p.appendChild(document.createTextNode(' '));
        echte.push(echt);
      });

      huelle.appendChild(p);
      eintraege.push({ el: p, echte: echte });
    });

    sek.appendChild(huelle);
    anker.parentNode.insertBefore(sek, anker);

    if (ruhig()) {
      /* Sofort vollstaendig, ohne jede Bewegung. */
      eintraege.forEach(function (e) {
        e.echte.forEach(function (x) { x.style.opacity = '1'; });
      });
      return true;
    }

    eintraege.forEach(function (e) { e.el.setAttribute('data-mmk-bereit', ''); });

    var imBild = false;
    var geplant = false;

    function zeichnen() {
      geplant = false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;
      /* Dieselben Marken wie in der Vorlage: die Zeile beginnt sich zu fuellen,
         wenn sie bei 85 % der Fensterhoehe steht, und ist voll, sobald sie 40 %
         erreicht. Kein zusaetzlicher Scrollweg, die Seite bleibt so lang wie
         vorher - das ist Merts Laengenregel vom 29.08.2026. */
      var start = vh * 0.85;
      var ende = vh * 0.40;
      var spanne = Math.max(1, start - ende);

      for (var z = 0; z < eintraege.length; z++) {
        var e = eintraege[z];
        var r = e.el.getBoundingClientRect();
        var p = grenze((start - r.top) / spanne, 0, 1);
        var n = e.echte.length;
        for (var i = 0; i < n; i++) {
          var von = i / n;
          var a = grenze((p - von) * n, 0, 1);
          e.echte[i].style.opacity = a.toFixed(3);
        }
      }
    }

    function planen() {
      if (geplant || !imBild || document.hidden) return;
      geplant = true;
      window.requestAnimationFrame(zeichnen);
    }

    if (window.IntersectionObserver) {
      new window.IntersectionObserver(function (eintr) {
        imBild = eintr[0].isIntersecting;
        if (imBild) planen();
      }, { rootMargin: '120px 0px' }).observe(sek);
    } else {
      imBild = true;
    }

    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) planen();
    });

    /* Einmal rechnen, damit der Stand schon vor dem ersten Scrollen stimmt -
       mit setTimeout als Rueckfall, weil requestAnimationFrame in einem
       versteckten Tab gar nicht laeuft (am 04.09.2026 mehrfach gemessen). */
    imBild = true;
    window.requestAnimationFrame(zeichnen);
    window.setTimeout(function () { if (!geplant) zeichnen(); }, 80);

    return true;
  }

  function anlauf() {
    if (bauen()) return;
    /* Die Zielsektionen entstehen selbst erst per Skript. Statt blind zu
       wiederholen wird auf ihr Auftauchen gewartet. */
    var wache = new window.MutationObserver(function () {
      if (bauen()) wache.disconnect();
    });
    wache.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { wache.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anlauf);
  } else {
    anlauf();
  }
})();
